import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProfileService } from '../profile.service';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-profile-main',
    templateUrl: './profile-main.component.html',
    styleUrl: './profile-main.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, RouterLinkActive, RouterOutlet]
})
export class ProfileMainComponent {

  constructor(
    private profileService: ProfileService
  ) { }

}
